import { Alert, AlertTitle, Button } from '@mui/material'
import { Brand } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'

import useManageBrandDialog from '@src/components/brands/useManageBrandDialog'
import useCurrentRetailerAccount from '@src/lib/useCurrentRetailerAccount'

import { useCustomFields } from './customFieldsContext'

const MissingCustomFieldsAlert: React.FC<{ brandId?: Brand['id'] }> = (
  props,
) => {
  const { ensureCurrentRetailerAccount } = useCurrentRetailerAccount()
  const customFieldsContext = useCustomFields()
  const manageBrandDialog = useManageBrandDialog({
    onClose: () => {
      customFieldsContext.refetch()
    },
  })

  const retailerId = ensureCurrentRetailerAccount.retailers?.find(
    (x) => x.brand_id === props.brandId,
  )?.id

  return (
    <>
      <Alert severity="warning">
        <AlertTitle>{I18n.t('customFields.alert.title')}</AlertTitle>
        {I18n.t('customFields.alert.message')}
        <Button
          variant="contained"
          color="warning"
          fullWidth
          onClick={() => {
            manageBrandDialog.showManageBrandDialog({
              initialTab: 'custom_fields',
              retailerId: retailerId || '',
              shouldHighlightMissing: true,
              validationMode: 'custom_fields',
            })
          }}
        >
          {I18n.t('customFields.alert.buttonLabel')}
        </Button>
      </Alert>
    </>
  )
}

export default MissingCustomFieldsAlert
